import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Login from "../pages/Login";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import RootRedirect from "./RootRedirect";
import { APP_ROUTES } from "../constants";
import Chat from "../pages/Chat"

const ProtectedLayout = () => (
  <ProtectedRoute>
    <Outlet />
  </ProtectedRoute>
);

const AppRoutes = () => (
  <Routes>
    <Route path={APP_ROUTES.LOGIN} element={<Login />} />
    <Route
      path={APP_ROUTES.FORGOT_PASSWORD}
      element={<div>Forgot Password Page</div>}
    />
    <Route path={APP_ROUTES.HOME} element={<RootRedirect />} />

    <Route element={<ProtectedLayout />}>
      <Route path={APP_ROUTES.CHAT} element={<Chat />} />
    </Route>

    <Route path="*" element={<Navigate to={APP_ROUTES.HOME} replace />} />
  </Routes>
);

export default AppRoutes;
